var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_63_3490",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_63_3490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20008 0C11.1699 0 14.4002 3.19545 14.4002 7.12273C14.4002 8.77273 13.8281 10.2932 12.8722 11.5023L19.7002 18.2682C20.1026 18.6682 20.1002 19.3114 19.6909 19.7068C19.4886 19.9023 19.2235 20 18.9607 20C18.6979 20 18.4235 19.9 18.2188 19.6977L11.3792 12.9182C10.2001 13.7523 8.75824 14.2455 7.20008 14.2455C3.23027 14.2455 0 11.05 0 7.12273C0 3.19545 3.23027 0 7.20008 0ZM7.20008 12.4386C10.1513 12.4386 12.5513 10.0545 12.5513 7.12273C12.5513 4.19091 10.1513 1.80682 7.20008 1.80682C4.24889 1.80682 1.84886 4.19091 1.84886 7.12273C1.84886 10.0545 4.24889 12.4386 7.20008 12.4386ZM3.59074 7.20682C3.64423 7.60455 3.99307 7.89318 4.39075 7.89318C4.42563 7.89318 4.46284 7.89091 4.49773 7.88636C4.93959 7.82955 5.25123 7.43182 5.19308 6.99773C5.03262 5.81364 6.38147 5.19546 6.43961 5.17045C6.84427 4.98864 7.02566 4.52273 6.84194 4.125C6.65822 3.72955 6.18612 3.55 5.77914 3.725C5.67681 3.77045 3.26748 4.84318 3.58841 7.20682H3.59074ZM5.29541 8.94091C5.12332 9.10909 5.02564 9.34091 5.02564 9.57727C5.02564 9.81364 5.12564 10.05 5.29541 10.2159C5.4675 10.3864 5.70704 10.4795 5.94891 10.4795C6.19077 10.4795 6.43031 10.3841 6.6024 10.2159C6.7745 10.0477 6.87217 9.81591 6.87217 9.57727C6.87217 9.33864 6.77217 9.10682 6.6024 8.94091C6.42798 8.77046 6.19077 8.675 5.94891 8.675C5.70704 8.675 5.46518 8.77273 5.29541 8.94091Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8e54fd2464b70ebaae78c1d5a47df140.svg";
export { ForwardRef as ReactComponent };